export default {
  shopList: [],
  areaList: [],
  mapShopList: [],
  selectValues: {
    status: [],
    potential: [],
    rPerformance: [],
    type: [],
    bizStatus: [],
    arrTag: [],
    requestType: '2'
  },
  bizoppId: '',
  currentlyGeo: {
    myLng: '',
    myLat: '',
    lng: '',
    lat: ''
  }
}
